import routeName from '../constant';

const routes = [
    {
        path: 'policy-val-notify',
        name: routeName.POLICY_VAL_NOTIFY,
        component: () => import('@/views/aplCatl640and631/AD/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '保單帳戶價值通知方式變更', leaveAlert: true, code: 'AD', unableBack: true },
    }];

export default routes;
